import { RaRecord, useGetOne, useRecordContext } from "react-admin";
import { FormCard } from "./FormCard";
import { EntitledForDrivingSchoolsBox, RolesInput } from "../resources/autovioEmployeesResource";
import { LoadingIndicator } from "./LoadingIndicator";

export const UserRolesForm = <U extends RaRecord, T extends RaRecord>({
  resource,
}: {
  resource: "autovioEmployees" | "employees";
}) => {
  const user = useRecordContext<U>();
  // FYI: A record with null value was found in the dev environment.
  const { data: userData, isLoading } = useGetOne<T>(resource, { id: user.id });

  if (isLoading) {
    return <LoadingIndicator />;
  } else if (!userData) {
    // Checking the record (userData) before rendering the form to avoid the "EditBase" default behaviour
    // of redirecting to the listing view when the record is not found.
    return null;
  }

  // The currently displayed record (instructor or employee) carries the driving school it belongs to.
  // Instructors and driving school managers are always entitled for exactly that driving school, but the
  // selection box below is only rendered for the other driving school roles, so we derive the value here.
  const drivingSchoolId: string | undefined = user.drivingSchoolId;

  return (
    <FormCard
      title="Rollen"
      resource={resource}
      id={user.id.toString()}
      transform={(data) => {
        const roles: Array<Role> = data.roles ?? [];
        let entitledForDrivingSchools: Array<string>;
        if (roles.some((it) => it === "instructor" || it === "drivingSchoolManager")) {
          entitledForDrivingSchools = drivingSchoolId ? [drivingSchoolId] : [];
        } else if (roles.some((it) => it !== "drivingSchoolManager" && it.startsWith("drivingSchool"))) {
          entitledForDrivingSchools = data.entitledForDrivingSchools;
        } else {
          entitledForDrivingSchools = [];
        }
        return { ...data, entitledForDrivingSchools };
      }}
    >
      <RolesInput label="" />
      <EntitledForDrivingSchoolsBox />
    </FormCard>
  );
};
